import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 10,
			r: 8,
			fill: "#4EA699"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_0_1",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 4,
			y: 4,
			width: 12,
			height: 12,
			children: /* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 4,
				width: 12,
				height: 12,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_0_1)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M8.77532 13.2257L5.69922 10.1496L6.64488 9.20391L8.77532 11.3343L13.3558 6.75391L14.3014 7.69957L8.77532 13.2257Z",
				fill: "white"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgCheckCircle);
export { ForwardRef as ReactComponent };
